import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { connect } from 'react-redux';
import styled from 'styled-components';

import LoginForm from 'containers/LoginPage/LoginForm';
import { requestLogin } from 'containers/LoginPage/actions';
import VersionTag from 'containers/AppContainer/VersionTag';

const Container = styled.div`
  .container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
  }
`;

export interface LoginPageProps {
  intl: IntlShape;
  requestLogin: Function;
}

const LoginPage: React.FC<LoginPageProps> = (props): JSX.Element => {
  return (
    <Container>
      <div className="container">
        <div></div>
        <LoginForm requestLogin={props.requestLogin} />
        <VersionTag />
      </div>
    </Container>
  );
};

const mapDispatchToProps = {
  requestLogin,
};

export default connect(null, mapDispatchToProps)(injectIntl(LoginPage));
export { LoginPage as LoginPageComponent };
